import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const MonthlyPaymentFixedInterestRate = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.monthlyPaymentFixedRateViewable', {
                        returnObjects: true,
                    })}
                    disabled={disabled}
                    name="monthlyPaymentFixedInterestRate.isViewable"
                />
            </Col>
        </Row>
    );
};

export default MonthlyPaymentFixedInterestRate;
